export default __webpack_public_path__ + "static/doug-daf39af1006cb09c7fcb5d4826673ab7.jpg";